"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _fetch = _interopRequireDefault(require("./../fetch"));

var _urlHelper = _interopRequireDefault(require("./url-helper"));

var _goToHelper = require("./go-to-helper");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

// import inIFrame from './iframe-detection-helper'
var CheckoutHelper =
/*#__PURE__*/
function () {
  function CheckoutHelper() {
    (0, _classCallCheck2["default"])(this, CheckoutHelper);
  }

  (0, _createClass2["default"])(CheckoutHelper, null, [{
    key: "buySite",

    /**
     *@param {object} contextOrHistory
     *@param {integer} siteId
     *@param {string} succesRedirect
     */
    value: function buySite(contextOrHistory, siteId, succesRedirect, purchaseOrigin, extraParameters) {
      var extraOptions = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if ((0, _isEmpty["default"])(purchaseOrigin)) {
        throw Error('Must impelemnt purchaseOrigin, this is used to track the payments made though our new control panel');
      }

      var url = "/v1.0/payment/upgrade?siteId=".concat(siteId, "&purchaseOrigin=").concat(purchaseOrigin);

      if (extraOptions && extraOptions.apiUrl) {
        url = extraOptions.apiUrl + url;
      }

      var options = (0, _objectSpread2["default"])({
        context: contextOrHistory,
        url: url,
        extraParameters: extraParameters,
        succesRedirect: succesRedirect
      }, extraOptions);
      CheckoutHelper.pay(options);
    }
    /*
     * buy an addon
     * @param {integer} resourceId, site-id or domain id or such
     * @param {string} sku
     */

  }, {
    key: "buyAddon",
    value: function buyAddon(options) {
      var context = options.context,
          resourceId = options.resourceId,
          scope = options.scope,
          extraParameters = options.extraParameters,
          onError = options.onError;
      var purchaseOrigin = options.purchaseOrigin,
          succesRedirect = options.succesRedirect,
          returnUrl = options.returnUrl;

      if (!purchaseOrigin) {
        purchaseOrigin = 'old_app_market';
      } // Get current url
      // Get base url


      succesRedirect = CheckoutHelper.getSuccessRedirect(succesRedirect);

      if (!returnUrl) {
        returnUrl = succesRedirect;
      } else {
        returnUrl = CheckoutHelper.getSuccessRedirect(returnUrl);
      }

      var body;

      if (scope) {
        body = {};

        if (scope === 'domain') {
          body = {
            domainId: resourceId
          };
        } else if (scope === 'site') {
          body = {
            siteId: resourceId
          };
        }
      }

      var buyOptions = {
        context: context,
        body: body,
        succesRedirect: succesRedirect,
        onError: onError
      };
      var extraParametersString = '';

      if (extraParameters) {
        for (var param in extraParameters) {
          extraParametersString += "&".concat(param, "=").concat(encodeURIComponent(extraParameters[param]));
        }
      }

      var sku = options.sku.toUpperCase();

      if (resourceId) {
        buyOptions.url = "/v1.0/payment/purchase?sku=".concat(sku, "&resourceId=").concat(resourceId, "&purchaseOrigin=").concat(purchaseOrigin, "&returnUrl=").concat(returnUrl) + extraParametersString;
        CheckoutHelper.pay(buyOptions);
      } else {
        // account scope
        buyOptions.url = "/v1.0/payment/purchase?sku=".concat(sku, "&purchaseOrigin=").concat(purchaseOrigin, "&returnUrl=").concat(returnUrl) + extraParametersString;
        CheckoutHelper.pay(buyOptions);
      }
    }
    /**
     * buyDomain
     *
     * @static
     * @param {object} contextOrHistory
     * @param {string} domain
     * @param {string} succesRedirect
     * @param {string} purchaseOrigin
     *
     * @memberof CheckoutHelper
     */

  }, {
    key: "buyDomain",
    value: function buyDomain(contextOrHistory, domain, succesRedirect, purchaseOrigin, resourceId, options) {
      if ((0, _isEmpty["default"])(purchaseOrigin)) {
        throw Error('Must implement purchaseOrigin, this is used to track the payments made though our new control panel');
      } // Get current url
      // Get base url


      succesRedirect = CheckoutHelper.getSuccessRedirect(succesRedirect);
      var paramObj = {
        domain: domain,
        purchaseOrigin: purchaseOrigin,
        returnUrl: succesRedirect
      };

      if (resourceId) {
        paramObj.siteId = resourceId;
      }

      var url = "/v1.0/payment/domain-upgrade?".concat(_urlHelper["default"].param(paramObj));

      if (options && options.apiUrl) {
        url = options.apiUrl + url;
      }

      options = (0, _objectSpread2["default"])({}, options || {}, {
        context: contextOrHistory,
        url: url,
        succesRedirect: succesRedirect
      });
      CheckoutHelper.pay(options);
    }
    /**
     *@param {object} context
     */

  }, {
    key: "addPayPal",
    value: function addPayPal() {
      var chargeUnpaidInvoices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var formValues = arguments.length > 1 ? arguments[1] : undefined;
      var url = window.location.href;
      var body = {
        return_url: url,
        cancel_url: _urlHelper["default"].addQueryParamtersToUrl(url, {
          cancel: true
        }),
        error_url: _urlHelper["default"].addQueryParamtersToUrl(url, {
          error: true
        })
      };

      if (formValues) {
        body = (0, _objectSpread2["default"])({}, body, {
          first_name: formValues.firstName,
          last_name: formValues.lastName,
          address1: formValues.address1,
          country: formValues.country,
          city: formValues.city,
          state: formValues.state,
          phone: formValues.phone,
          postal_code: formValues.postalCode
        });
      }

      var fullUrl = _urlHelper["default"].getUrl(_urlHelper["default"].siteNames.API, '/v1.0/billing/add_paypal');

      if (chargeUnpaidInvoices) {
        fullUrl = _urlHelper["default"].addQueryParamtersToUrl(fullUrl, {
          unpaid: true
        });
      }

      return (0, _fetch["default"])(fullUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body),
        credentials: 'include'
      }).then(function (response) {
        if (!response.ok) {
          throw Error(response.statusText);
        }

        return response.json();
      }).then(function (obj) {
        return obj.redirect_url;
      });
    }
  }, {
    key: "cleanPhoneNumber",
    value: function cleanPhoneNumber(phone) {
      if (!phone) {
        return phone;
      }

      return phone.replace(/[^0-9+x]/g, '');
    } // copy model by hand, we want to strip out the credit card data before sending it to our server

  }, {
    key: "cleanContactInfo",
    value: function cleanContactInfo(contactInfo) {
      return {
        first_name: contactInfo.firstName,
        last_name: contactInfo.lastName,
        organization: contactInfo.organization,
        address1: contactInfo.address1,
        address2: contactInfo.address2,
        state: (0, _isEmpty["default"])(contactInfo.state) ? undefined : contactInfo.state,
        postal_code: contactInfo.postalCode,
        country: contactInfo.country,
        phone: this.cleanPhoneNumber(contactInfo.phone),
        email: contactInfo.email,
        city: contactInfo.city
      };
    }
  }]);
  return CheckoutHelper;
}();

CheckoutHelper.doPayment = function (url, body, doOkay, doRedirect, onError) {
  var fullUrl; // This is done so express editor can use own API instead of CP API.

  if (url.indexOf('//') === 0 || url.indexOf('http') === 0) {
    fullUrl = url;
  } else {
    fullUrl = _urlHelper["default"].getUrl(_urlHelper["default"].siteNames.API, url);
  }

  (0, _fetch["default"])(fullUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body),
    credentials: 'include'
  }).then(function (response) {
    if (!response.ok) {
      // TODO show erorr banner
      if (onError) {
        onError(response);
      }

      throw Error(response.statusText);
    }

    return response.json();
  }).then(function (obj) {
    if (obj.redirect) {
      doRedirect(obj.redirect_url);
    } else {
      var psid = obj.purchase_state_id;
      doOkay(psid);
    }
  })["catch"](function (ex) {
    if (onError) {
      onError(ex);
    }

    console.error(ex);
  });
};

CheckoutHelper.getSuccessRedirect = function (url) {
  url = url || '';
  return _urlHelper["default"].getUrl(_urlHelper["default"].siteNames.MY, url);
};

CheckoutHelper.pay = function (options) {
  if (!options.succesRedirect) {
    options.succesRedirect = CheckoutHelper.getSuccessRedirect();
  }

  var extraParametersString = '';

  if (options.extraParameters) {
    for (var param in options.extraParameters) {
      extraParametersString += "&".concat(param, "=").concat(encodeURIComponent(options.extraParameters[param]));
    }
  }

  if (!options.goToAction) {
    if (options.context && options.context.router) {
      options.goToAction = function (url) {
        return (0, _goToHelper.goToWithContext)(options.context, url);
      };
    } else {
      options.goToAction = function (url) {
        return (0, _goToHelper.goToWithHistory)(options.context, url);
      };
    }
  }

  CheckoutHelper.doPayment(options.url, options.body, function (psid) {
    if (psid) {
      var successRedirect = _urlHelper["default"].addQueryParamtersToUrl(options.succesRedirect, {
        psid: psid
      });

      options.goToAction(successRedirect);
    } else {
      options.goToAction(options.succesRedirect);
    }
  }, function (redirectUrl, transactionIds) {
    options.goToAction("".concat(redirectUrl, "&success=").concat(options.succesRedirect) + extraParametersString);
  }, options.onError);
};

var _default = CheckoutHelper;
exports["default"] = _default;